import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, of, Subject } from 'rxjs'

import { Clinic } from '../model/clinic'
import { Clinician } from '../model/clinician'
import { Facility } from '../model/facility'
import { ProductModel } from '../model/product'

const testClinic = new Clinic({
  email: '',
  image: '',
  modules: undefined,
  modulesPreferences: undefined,
  options: undefined,
  paymentProvider: undefined,
  pinCode: '',
  pricer: undefined,
  provider: undefined,
  settings: {},
  socialNetwork: undefined,
  twilioNumber: '',
  type: '',
  id: '00000000-aaaa-bbbb-cccc-111111111111',
  name: 'Testing Clinic',
  slug: 'test',
  languages: ['en'],
  phoneNumber: '',
})

@Injectable()
export class MockClinicService {
  static clinic = testClinic
  static clinicId = testClinic.id

  clinic = testClinic
  clinicId = testClinic.id

  refresh$ = new Subject<void>()

  clinicId$ = new BehaviorSubject(this.clinic.id)
  clinic$ = new BehaviorSubject(this.clinic)

  getClinicians(): Observable<Clinician[]> {
    return of([])
  }

  getProducts(): Observable<ProductModel[]> {
    return of([] as ProductModel[])
  }

  getLocations(): Observable<Facility[]> {
    return of([])
  }
}
